import { ESTATE_AUDIENCES, ESTATE_SERVICES } from "./index";
import { buildLegalClusterQA, toAxis, type WaveQA } from "../_qa/legal-clusters";

export type EstateQA = WaveQA;

export const ESTATE_REVIEWED_TH = "สิงหาคม 2569";
export const ESTATE_REVIEWED_ISO = "2026-08-07";

export const ESTATE_QA: EstateQA[] = buildLegalClusterQA({
  prefix: "estate",
  clusterTh: "งานพินัยกรรม มรดก และหนังสือมอบอำนาจ",
  authorityTh: "สำนักงานที่ดิน อำเภอ หรือศาลที่มีเขตอำนาจ",
  reviewedTh: ESTATE_REVIEWED_TH,
  volatileNote:
    "เงื่อนไขและแบบฟอร์มของแต่ละหน่วยงานเปลี่ยนได้ ควรยืนยันกับหน่วยงานก่อนดำเนินการ",
  topics: toAxis(ESTATE_SERVICES),
  extraTopics: toAxis(ESTATE_AUDIENCES, "aud"),
});

export const ESTATE_QA_BY_SLUG: Record<string, EstateQA> = Object.fromEntries(
  ESTATE_QA.map((qa) => [qa.slug, qa]),
);

export const ESTATE_QA_COUNT = ESTATE_QA.length;
